module.exports = __webpack_public_path__ + "static/media/12_Sample_House_new.9ec33573.jpg";